import {
    ESharedFunction,
    ESharedFunctionMultiple,
} from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { State } from "./State";

export function ShareState<TState>(
    name: ESharedFunction,
    currentState: TState,
    setState: React.Dispatch<React.SetStateAction<TState>>,
    shouldAllowSubscriptions: boolean = false
) {
    State.ShareFunction<TState>(name, currentState, setState);

    if (shouldAllowSubscriptions) {
        var eventDetail =
            currentState !== undefined ? { detail: currentState } : {};

        var event = new CustomEvent<TState>(ESharedFunction[name], eventDetail);
        document.dispatchEvent(event);
    }
}

export function ShareStateMultiple<S>(
    name: ESharedFunctionMultiple,
    uniqueKey: string,
    currentState: any,
    setState: React.Dispatch<React.SetStateAction<S>>
) {
    React.useEffect(() => {
        State.ShareFunctionMultiple<S>(name, uniqueKey, currentState, setState);
    }, [name, uniqueKey, currentState, setState]);
}

export function SubscribeToSharedState<TState>(
    name: ESharedFunction,
    handler: (payload: TState) => void
) {
    const eventName = ESharedFunction[name];

    const EventHandler = (event: CustomEvent<TState>) => {
        const payload = event.detail;
        handler(payload);
    };

    React.useEffect(() => {
        document.addEventListener(eventName, EventHandler);
        return () => document.removeEventListener(eventName, EventHandler);
    }, []);
}
